module.exports = __webpack_public_path__ + "img/module2-05.410fbbde.jpg";